var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLavaEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1447 484.6",
    style: {
      enableBackground: "new 0 0 1447 484.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1447,264v108.4c0,40.7-33,73.6-73.6,73.6s-73.6-33-73.6-73.6V177.2c0-33.6-27.3-60.9-60.9-60.9 c-33.6,0-60.9,27.3-60.9,60.9v228.1c0,40.7-33,73.6-73.6,73.6c-40.7,0-73.6-33-73.6-73.6V186.6c0-38.8-31.5-70.3-70.3-70.3 s-70.3,31.5-70.3,70.3v65.7c0,39-31.6,70.6-70.6,70.6c-39,0-70.6-31.6-70.6-70.6v-72c0-35.3-28.6-63.9-63.9-63.9 c-35.3,0-63.9,28.6-63.9,63.9v227.7c0,42.3-34.3,76.7-76.7,76.7s-76.7-34.3-76.7-76.7v-221c0-39-31.6-70.6-70.6-70.6 s-70.6,31.6-70.6,70.6v230.9c0,28.3-22.9,51.2-51.2,51.2c-28.3,0-51.2-22.9-51.2-51.2V167.5c0-28.3-22.9-51.2-51.2-51.2 c-28.3,0-51.2,22.9-51.2,51.2v177.6c0,33.6-27.3,60.9-60.9,60.9S0,378.7,0,345.1V207.6c0-0.9,0-1.7,0-2.6V83.9V39L0,0h1447v60v23.9 v125.3V226V264z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLavaEvent);
export default __webpack_public_path__ + "static/media/lava_event.ac0f9bd74a046b8c757f9f3ec96d231a.svg";
export { ForwardRef as ReactComponent };